<template>
  <div class="company-materials-module">
    <div class="desp">
      <div class="desp-header">Upload</div>
      <div>
        <!-- 公司设立 -->
        <Incorporation :detail="detail" v-if="detail.businessType == 'COMPANY_INCORPORATION'"></Incorporation>
        <!-- 服务转移 -->
        <Transfer :detail="detail" v-if="detail.businessType == 'SERVICE_TRANSFER'"></Transfer>
        <!-- 综合性公司服务 -->
        <ComprehensiveCustomized :detail="detail" v-if="detail.businessType == 'COMPREHENSIVE_CUSTOMIZED'"></ComprehensiveCustomized>
      </div>
    </div>
  </div>
</template>

<script>
import Incorporation from "./Incorporation";
import Transfer from "./Transfer";
import ComprehensiveCustomized from "./ComprehensiveCustomized";
export default {
  components: { Incorporation, Transfer, ComprehensiveCustomized },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          businessType: "",
          applymentStatus: "",
          registeredOfficeAddressCertificateUrl: [],
          registeredOfficeShareholdingStructureUrls: [],
          authoritiesApprovalFileUrls: [],
          companyMemberList: [],
          applicantIdentificationUrls: [],
          authorizationUrls: [],
          applicantPosition: "",
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.company-materials-module {
  .files-wrapper {
    width: 100%;
  }

  .company-files-wrapper {
    .el-col {
      margin-bottom: 20px;
    }
  }

  .shareholder-file-wrapper {
    .member-info {
      color: #353744;
      font-weight: normal;
      // margin-bottom: 15px;

      .name {
        width: fit-content;
        font-size: 16px;
        line-height: 16px;
        margin-right: 10px;
      }
      .held {
        font-size: 13px;
      }
    }
  }

  .desp-items-group-header {
    .title {
      padding: 10px 0;
    }
  }
}
</style>
